import { Alert, App, Button, Card, Modal, Space, Spin, Typography } from 'antd'
import { FC, useState } from 'react'
import { DEFAULT_ERROR } from '../../../App'
import { fetchSmartBannerEmbedSnippet } from '../../../services/SmartBannerService'

const { Text, Paragraph } = Typography

interface Props {}

const SmartBannerViewCodeModal: FC<Props> = () => {
  const { message } = App.useApp()
  const [open, setOpen] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [snippet, setSnippet] = useState<string | undefined>(undefined)
  const [hasError, setHasError] = useState<boolean>(false)

  const loadSnippet = () => {
    setIsLoading(true)
    setSnippet(undefined)
    setHasError(false)
    fetchSmartBannerEmbedSnippet()
      .then((result) => {
        setSnippet(result.snippet)
      })
      .catch(() => {
        setHasError(true)
        message.error(DEFAULT_ERROR)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const onClick = () => {
    setOpen(true)
    loadSnippet()
  }

  return (
    <>
      <Card styles={{ body: { padding: 10 } }} className="w-full">
        <Space className="w-full space-between align-items-center" size={10}>
          <Space orientation="vertical" size={0}>
            <Text>HTML Code</Text>
            <Text type="secondary">Mannualy install banner</Text>
          </Space>
          <Button onClick={onClick}>View code</Button>
        </Space>
      </Card>

      <Modal
        title="View code"
        open={open}
        onCancel={() => setOpen(false)}
        footer={[
          <Button key="close" onClick={() => setOpen(false)}>
            Close
          </Button>,
        ]}
      >
        <Space orientation="vertical" size={10} className="w-full">
          {isLoading && (
            <div style={{ textAlign: 'center' }}>
              <Spin />
            </div>
          )}
          {!isLoading && hasError && (
            <Alert
              type="error"
              showIcon
              message="Could not load the code snippet."
              action={
                <Button size="small" onClick={loadSnippet}>
                  Retry
                </Button>
              }
            />
          )}
          {!isLoading && snippet && (
            <>
              <Text type="secondary">
                Paste this snippet into your website's &lt;head&gt;.
              </Text>
              <Card styles={{ body: { padding: 10 } }} className="w-full">
                <Paragraph
                  copyable={{ text: snippet }}
                  code
                  className="m-0"
                  style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}
                >
                  {snippet}
                </Paragraph>
              </Card>
            </>
          )}
        </Space>
      </Modal>
    </>
  )
}

type SmartBannerViewCodeModalType = {
  ViewCodeModal: typeof SmartBannerViewCodeModal
}

export { SmartBannerViewCodeModal, type SmartBannerViewCodeModalType }
